import Alpine from 'alpinejs'
import I96StickyHeader from '../libs/stickyheader/i96-sticky_header.js'
import I96Adminbar from "../libs/adminbar/i96-adminbar.class.js";
import I96Parallax from "../libs/parallax/i96-parallax.class.js";
import LeAccordion from "../libs/accordion/le-accordion.class.js";
import i96Toolbox from "./includes/i96Toolbox.class.js";
import I96Menu from "../libs/menu/i96-menu.class.js";
import I96InternalScroll from "../libs/internalscroll/i96-internal_scroll.class.js";
import I96StickyStuff from "../libs/stickystuff/i96-sticky_stuff.js";
import I96MobileMaxText from "../libs/mobilemaxtext/i96-mobile_max_text.js";
import StagerNewsletter from "./includes/stager-newsletter.js";

// NEWSLETTER
// -------------------------
const newsletter = new StagerNewsletter();

// PHOTOSWIPE
// -------------------------
  import PhotoSwipeLightbox from 'photoswipe/lightbox';
  import 'photoswipe/style.css';

  const lightbox = new PhotoSwipeLightbox({
    // may select multiple "galleries"
    gallery: '#gallery--getting-started',

    // Elements within gallery (slides)
    children: 'a',

    arrowPrevSVG: '<svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" d="M21.85 29.802a1.152 1.152 0 0 0 .815-1.967L9.814 14.982l12.85-12.85a1.152 1.152 0 1 0-1.63-1.63L7.37 14.167c-.45.45-.45 1.18 0 1.63l13.666 13.666c.225.225.52.338.815.338Z"></path></svg>',
    arrowNextSVG: '<svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" d="M8.15.198a1.152 1.152 0 0 0-.815 1.967l12.851 12.852-12.85 12.85a1.153 1.153 0 1 0 1.63 1.63L22.63 15.833c.45-.45.45-1.18 0-1.63L8.965.536A1.148 1.148 0 0 0 8.15.198Z"></path></svg>',

    pswpModule: () => import('photoswipe')
  });
// -------------------------


window.i96t = new i96Toolbox();




document.addEventListener("DOMContentLoaded", function(){

  // Handler when the DOM is fully loaded
  console.log('js executed...');



// GALERIE SHOW MORE
// --------------------------
  const show_more = document.querySelector('.galerie-show-more');
  if (show_more) {
    show_more.addEventListener('click', () => {
      console.log('click');
      var images = document.querySelectorAll('.galerie-wrapper .galerie-entry.hidden');

      images.forEach((ele, index) => {
        console.log(ele);
        if (index < 6) {
          ele.classList.remove('hidden');
          var img_temp = ele.querySelector('img');
          if (img_temp) {
            img_temp.setAttribute('loading', 'eager');
          }
        }
      });

      images = document.querySelectorAll('.galerie-wrapper .galerie-entry.hidden');
      console.log(images);
      if (!images.length) {
        document.querySelector('.galerie-show-more').classList.add('hidden');
      }
    });
  }
// --------------------------


  lightbox.init();

  window.Alpine = Alpine
  Alpine.start()

  const sticky_header  = new I96StickyHeader({
    threshold: 400
  });

  const parallax = new I96Parallax({
    debug: false
  });

  const menu = new I96Menu();

  const admin_bar = new I96Adminbar();

  const internal_scroll = new I96InternalScroll();

  const sticky_stuff = new I96StickyStuff();

  const mobil_max_text = new I96MobileMaxText();

  const le_accordion = new LeAccordion({debug: false});

//  const akk = new LeAccordion();

});
